import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"
import { getCookie } from "./utils/getCookie";
import { setCookie } from "./utils/setCookie";
import { geoLocationService } from "./services/geolocation.service";

export function RegionalPopup (options = {}) {
  this.settings = {
    // selectors
    popupSelector: '.regional-popup',
    underlaySelector: '.regional-popup__underlay',
    containerSelector: '.regional-popup__container',
    headingSelector: '.regional-popup__heading',
    descriptionSelector: '.regional-popup__description',
    buttonSelector: '.regional-popup__cta',
    dismissButtonSelector: '.regional-popup__dismiss',
    closeSelector: '.regional-popup__close',

    // content
    heading: 'Regional Popup Heading',
    description: 'Regional Popup Heading',
    buttonLabel: 'Yes - visit',
    buttonHref: '/pages/contact',
    dismissLabel: 'No - dismiss',

    // functions
    isPopupCondition: function(country) {
      return country === 'MY'
    },

    // config
    debug: false,
    bodyClass: 'regional-popup--visible',
    countryIsoCode: null,
    cookieTimeInDays: 1,
  }

  Object.assign(this.settings, options)

  this.init = async () => {
    const { delay } = this.settings

    if(!this.hasDisplayed()) {
      const isPopupCondition = await this.checkCustomerLocation();

      if (isPopupCondition || this.settings.debug) {
        this._bindEvents();
        this._renderPopupUI();
        
        setTimeout(() => this.showPopup(), delay);
      }
    }
  }

  this.hasDisplayed = () => {
    return Boolean(getCookie("regional-popup:hide"));
  },

  this._renderPopupUI = () => {
    const {
      headingSelector,
      heading,
      description,
      descriptionSelector,
      buttonSelector,
      buttonLabel,
      buttonHref,
      dismissButtonSelector,
      dismissLabel} = this.settings
    const $heading = document.querySelector(headingSelector)
    const $description = document.querySelector(descriptionSelector)
    const $button = document.querySelector(buttonSelector)
    const $dismissButton = document.querySelector(dismissButtonSelector)

    if ($heading) {
      $heading.innerHTML = heading
    }
    if ($description) {
      $description.innerHTML = description
    }
    if ($button) {
      $button.innerHTML = buttonLabel
      $button.setAttribute('href', buttonHref)
    }
    if ($dismissButton) {
      $dismissButton.innerHTML = dismissLabel
    }
  }

  this._bindEvents = () => {
    const {
      closeSelector,
      underlaySelector,
      buttonSelector,
      dismissButtonSelector,
      cookieTimeInDays
    } = this.settings;

    const $closeButton = document.querySelector(closeSelector);
    const $underlay = document.querySelector(underlaySelector);
    const $dismissButton = document.querySelector(dismissButtonSelector);
    const $acceptButton = document.querySelector(buttonSelector);
    const buttons = [$dismissButton, $closeButton, $underlay];

    // setCookie() is defined globally due to the set up of space having one single 'assets/custom.js' file
    buttons.forEach(button => {
      button && button.addEventListener('click', (e) => {
        this.closePopup(e)
        setCookie("regional-popup:hide", 'true', cookieTimeInDays)
      })
    })

    $acceptButton && $acceptButton.addEventListener('click', (e) => {
      setCookie("regional-popup:hide", 'true', cookieTimeInDays)
    })
  }

  this.closePopup = (event) => {
    const { popupSelector } = this.settings
    const $popup = document.querySelector(popupSelector)

    event.preventDefault();
    $popup.style.display = 'none';
    this.scrollLock(false);

    document.dispatchEvent(new Event('regional-popup:close'));
  }

  this.showPopup = () => {
    const { popupSelector } = this.settings
    const $popup = document.querySelector(popupSelector)
    $popup.style.display = 'block'
    this.scrollLock(true)
  }

  this.checkCustomerLocation = async () => {
    const countryIsoCode = await this.getCustomerLocation()

    // set the country
    this.settings.countryIsoCode = countryIsoCode

    return this.settings.isPopupCondition(countryIsoCode);
  }

  this.getCustomerLocation = async () => {
    const response = await geoLocationService.fetchAndSaveUserCountryIsoCode();

    document.dispatchEvent(new CustomEvent('regional-popup:get-customer-location', {
      detail: {
        userCountryCode: response
      }
    }));

    return response
  }

  this.scrollLock = (isLocked) => {
    const { bodyClass, containerSelector } = this.settings
    const $container = document.querySelector(containerSelector)

    if(isLocked) {
      document.body.classList.add(bodyClass)
      disableBodyScroll($container)
    } else {
      document.body.classList.remove(bodyClass)
      enableBodyScroll($container)
    }
  }
}